<template>
<div class="chapter">
<div class="inner_page">
<div class="ContentsPage">
<h1><span class="ChapterTitle">Contents</span></h1>
<p><a href="#/Text/Acknowledgments">Acknowledgments</a></p>
<p><a href="#/Text/Introduction">Introduction</a></p>
<ol>
<li>
<p><a href="#/Text/Chapter1"><span class="ChapterTitle">The once and future King</span></a></p>
<p><span class="Subtitle">Who rules the world?</span></p>
<p>Bible study: Psalm 2</p>
</li>
<li>
<p><span href="#/Text/Chapter2" title="Link target outside of Sample"><span class="ChapterTitle">Naked ape or divine image?</span></span></p>
<p><span class="Subtitle">Who am I?</span></p>
<p>Bible study: Psalm 8 and Hebrews 2:5–18</p>
</li>
<li>
<p><span href="#/Text/Chapter3" title="Link target outside of Sample"><span class="ChapterTitle">God’s marriage</span></span></p>
<p><span class="Subtitle">Is a perfect relationship possible?</span></p>
<p>Bible study: Ezekiel 16</p>
</li>
<li>
<p><span href="#/Text/Chapter4" title="Link target outside of Sample"><span class="ChapterTitle">Wealth and possessions</span></span></p>
<p><span class="Subtitle">Your money or your life?</span></p>
<p>Bible study: 1 Timothy 6:6–19</p>
</li>
<li>
<p><span href="#/Text/Chapter5" title="Link target outside of Sample"><span class="ChapterTitle">The Holy Spirit</span></span></p>
<p><span class="Subtitle">What is his work?</span></p>
<p>Bible study: The Spirit in John’s Gospel</p>
</li>
<li>
<p><span href="#/Text/Chapter6" title="Link target outside of Sample"><span class="ChapterTitle">God and the nations</span></span></p>
<p><span class="Subtitle">What is God’s plan for the world?</span></p>
<p>Bible study: Isaiah 66:18–24</p>
</li>
</ol>
<p><span href="#/Text/Conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p><span href="#/Text/FurtherReading" title="Link target outside of Sample">Further reading</span></p>
<p><span href="#/Text/Notes" title="Link target outside of Sample">Notes</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?c07b2222